import { WholeNumber_Schema } from "@/utilities/schema";

export const UserId_Schema = WholeNumber_Schema;
